<img src="/assets/img/cintra-logo.svg" alt="Cintra logo" width="138px" height="40px" />
<img src="/assets/img/cloud.svg" alt="Cintra cloud" width="40px" height="28px" />
